import '@linktivity/link-styles';
import App from '@nankai/admin/App';
import '@nankai/admin/i18n';
import '@nankai/admin/styles/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './context/AuthContext';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
